<template>
  <v-overlay
    :model-value="modelValue"
    contained
    class="onboarding-content-overlay"
    persistent
    :scrim="false"
    scroll-strategy="block"
  >
    <div class="onboarding-content-overlay__panel">
      <div
        class="onboarding-content-overlay__inner text-center"
        role="status"
        aria-live="polite"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="48"
          width="4"
          class="mb-4"
        />
        <p class="text-h6 font-weight-medium mb-2">
          {{ title }}
        </p>
        <p class="text-body-1 text-medium-emphasis mb-0">
          {{ hint }}
        </p>
      </div>
    </div>
  </v-overlay>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean
  title: string
  hint: string
}>()
</script>

<style scoped>
.onboarding-content-overlay :deep(.v-overlay__content) {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  margin: 0;
  inset: 0;
  transform: none;
}

.onboarding-content-overlay__panel {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(var(--v-theme-surface));
  padding: 24px;
}

.onboarding-content-overlay__inner {
  max-width: 420px;
}
</style>
